import { FilterContainer } from './FilterContainer';
import { CheckBoxFilter } from './CheckBox';

export default {
  Container: FilterContainer,
  CheckBox: CheckBoxFilter,
};
